<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m12 17.77 4.151 2.505c.757.458 1.692-.221 1.49-1.083L16.54 14.47l3.669-3.178c.668-.58.31-1.678-.57-1.752l-4.829-.41-1.89-4.458c-.344-.813-1.496-.813-1.84 0L9.19 9.13l-4.828.41c-.882.074-1.24 1.173-.57 1.752L7.46 14.47l-1.102 4.722c-.2.861.734 1.54 1.491 1.083L12 17.77Z"
    />
  </svg>
</template>
